import { css } from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import { Icon } from './styles'

const themes = {
  primary: ({ disabled, submitting }) => css`
    background: ${color.AQUAMARINE};
    color: ${color.WHITE};
    white-space: nowrap;

    &:before {
      transition: border-color;
      content: '';
      position: absolute;
      top: 3px;
      left: 3px;
      right: 3px;
      bottom: 3px;
      border-radius: 2px;
      display: block;
      border: solid 1px transparent;
      transition: border-color 0.2s;
    }

    &:hover {
      background: ${color.SCOOTER};
      color: ${color.WHITE};
    }

    &:focus:not(:active) {
      background: ${color.SCOOTER};

      &:before {
        border-color: ${color.WHITE};
      }
    }

    &:active {
      background: ${color.SCOOTER};
      box-shadow: inset 0 2px 0 0 ${color.ATOLL};
    }

    // div buttons don't have the :disabled psuedo class
    // so we needed a way to also pay attention to the disabled prop.
    ${disabled && '&,'}
    &:disabled {
      color: #fff;
      background: ${color.SILVER};
      cursor: not-allowed;

      &:hover,
      &:active {
        color: #fff;
        background: ${color.SILVER};
        box-shadow: none;
        text-decoration: none;
      }
    }

    ${submitting &&
    `
      background: ${color.SILVER};
      cursor: default;

      ${Icon} {
        opacity: 0;
        transform: scale(0)
      }
    `}
  `,

  alt: () => css`
    background: none;
    color: #0e60c9;
    border: solid 1px #0e60c9;

    &:before {
      transition: border-color;
      content: '';
      position: absolute;
      top: 3px;
      left: 3px;
      right: 3px;
      bottom: 3px;
      border-radius: 2px;
      display: block;
      border: solid 1px transparent;
      transition: border-color 0.2s;
    }

    &:hover {
      color: #0e60c9;
      background: ${color.AQUA_OVERLAY};
    }

    &:focus:not(:active) {
      color: #0e60c9;
      background: ${color.AQUA_OVERLAY};

      &:before {
        border-color: #0e60c9;
      }
    }

    &:active {
      background: ${color.AQUA_OVERLAY};
      box-shadow: inset 0 0 0 2px #0e60c9;
      text-decoration: none;
    }

    &:disabled {
      background: ${color.WHITE};
      color: ${color.SILVER};
      border-color: ${color.SILVER};
    }
  `,

  altInvert: ({ noeffects }) => css`
    background: none;
    color: ${color.WHITE};
    border: solid 1px ${color.WHITE};

    ${!noeffects &&
    `
      &:hover {
        color: ${color.WHITE};
        background: ${color.AQUA_OVERLAY};
      }
    
      &:focus:not(:active) {
        color: ${color.WHITE};
        background: ${color.AQUA_OVERLAY};
        box-shadow: inset 0 0 0 1px ${color.WHITE};
      }
    `}
  `,

  feedback: () => css`
    background: none;
    color: ${color.WHITE};
    border: solid 1px ${color.WHITE};

    &:hover {
      color: ${color.WHITE};
      background: rgba(255, 255, 255, 0.25);
    }

    &:focus:not(:active) {
      color: ${color.WHITE};
      background: rgba(255, 255, 255, 0.25);
      box-shadow: inset 0 0 0 1px ${color.WHITE};
    }

    &:active {
      color: ${color.WHITE};
      background: rgba(255, 255, 255, 0.25);
    }

    &:disabled {
      background: none;
      color: ${color.SILVER};
      border-color: ${color.SILVER};
    }
  `,

  cancel: () => css`
    background: ${color.WHITE};
    color: ${color.AQUAMARINE};

    &:hover {
      color: ${color.AQUAMARINE};
      background: ${color.AQUA_OVERLAY};
    }

    &:focus:not(:active) {
      color: ${color.AQUAMARINE};
      background: ${color.AQUA_OVERLAY};
      border-width: 3px;
    }

    &:active {
      color: ${color.WHITE};
      background: ${color.AQUAMARINE};
    }

    &:disabled {
      background: ${color.WHITE};
      color: ${color.SILVER};
      border-color: ${color.SILVER};
    }
  `,

  delete: () => css`
    background: ${color.WATERMELON};
    color: ${color.WHITE};
    border: solid 1px transparent;

    &:hover {
      color: ${color.WHITE};
      background: ${color.AMARANTH};
      border-color: ${color.AMARANTH};
    }

    &:focus:not(:active) {
    }

    &:active {
      background: ${color.WATERMELON};
      box-shadow: inset 0 2px 0 0 ${color.AMARANTH};
    }

    &:disabled {
      color: ${color.SILVER};
    }
  `,

  disabled: ({ noeffects }) => css`
    background: ${color.SILVER};
    color: ${color.WHITE};
    border: solid 1px transparent;

    ${!noeffects &&
    `
    &:hover {
      color: ${color.WHITE};
      background: ${color.GREY};
      border-color: ${color.GREY};
    }

    &:focus:not(:active) {
    }

    &:active {
      background: ${color.SILVER};
      box-shadow: inset 0 2px 0 0 ${color.GREY};
    }

    &:disabled {
      color: ${color.SILVER};
    }
    `}

    ${noeffects &&
    `
       cursor: auto;
    `}
  `,

  facebook: () => css`
    background: #4267b2;
    color: ${color.WHITE};

    &:hover {
      background: #4267b2;
    }

    &:focus:not(:active) {
      background: #4267b2;
    }

    &:active {
      background: #4267b2;
    }
  `,
}

export default themes
